export const parseBulletPoints = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const listItems = doc.querySelectorAll('li');
    return Array.from(listItems).map(item => item.textContent);
  };
  